export const THYME_PHONE_NUMBER = '12015268484'
export const THYME_PHONE_NUMBER_DISPLAY = '201-526-8484'

export const THYME_EMAIL = 'careteam@thymecare.health'

export const EXTERNAL_URL_COMMUNITY_RESOURCES =
  'https://resources.thymecare.com'
export const EXTERNAL_URL_ABOUT_THYME = 'https://www.thymecare.com'
export const EXTERNAL_URL_PRIVACY_POLICY = 'https://www.thymecare.com/legal'
